import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { Router } from '@angular/router';
import { Guide } from '../guide';
import { CKEDITORCONFIG } from '../ckeditor-config';
import * as Editor from '../../libs/ckeditor';


@Component({
  selector: 'app-guide-create',
  templateUrl: './guide-create.component.html',
  styleUrls: ['./guide-create.component.css']
})
export class GuideCreateComponent implements OnInit {

  guideForm!: FormGroup;
  nameIsNull = false;

  editorConfig: any = CKEDITORCONFIG;

  public Editor = Editor;

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService,
    private router: Router
  ) { }

  ngOnInit() {
    this.guideForm = this.builder.group({
      name: "",
      comment: ""
    });
  }

  sendForm(){
    this.nameIsNull = false;
    if(this.guideForm.value.name == ""){
      console.log("name is empty");
      this.nameIsNull = true;
      return;
    }

    this.httpService.postGuide(
      new Guide(this.guideForm.value.name, this.guideForm.value.comment)
    ).subscribe(() => {
      console.log("success");
      this.router.navigateByUrl("/management/guides");
    });
  }

}
